import { takeLatest } from 'redux-saga/effects'

import { ERROR, FETCH_DATA } from '../types'

import { apiErrorWorker, fetchDataWorker } from './worker'

export function* watchApiError() {
  yield takeLatest(ERROR, apiErrorWorker)
  yield takeLatest(FETCH_DATA, fetchDataWorker)
}
